import { ajax as ajaxrx } from "rxjs/observable/dom/ajax";
import { Observable } from "rxjs/Observable";
import { AjaxResponse } from "rxjs/observable/dom/AjaxObservable";
import "rxjs/add/operator/mergeMap";
import "rxjs/add/operator/map";
import "rxjs/add/operator/catch";
import cookie from "react-cookies";

export class authenticatedAjax {

    private static API_HOST: string = process.env.REACT_APP_API_HOST;

    private static defaultHeaders: {} = {
        "X-APP-RELAYSTATE": window.location.href
    };

    static get(url: string, headers?: {}): Observable<AjaxResponse> {
        return this.getTokenAsObservable()
            .flatMap(
                (token: string) => {
                    const completeHeaders = {
                        "X-XSRF-TOKEN": token,
                        ...headers,
                        ...this.defaultHeaders,
                    };
                    return ajaxrx({
                        url: this.API_HOST + url,
                        responseType: "text",
                        headers: completeHeaders,
                        withCredentials: true
                    });
                },
            );
    }

    static getBlob(url: string, headers?: {}): Observable<AjaxResponse> {
        return this.getTokenAsObservable()
            .flatMap(
                (token: string) => {
                    const completeHeaders = {
                        "X-XSRF-TOKEN": token,
                        ...headers,
                        ...this.defaultHeaders,
                    };
                    return ajaxrx({
                        url: this.API_HOST + url,
                        responseType: "blob",
                        headers: completeHeaders,
                        withCredentials: true
                    });
                },
            );
    }

    static post(url: string, data?: {}, headers?: {}): Observable<AjaxResponse> {
        return this.getTokenAsObservable()
            .flatMap(
                (token: string) => {
                    const completeHeaders = {
                        "X-XSRF-TOKEN": token,
                        ...headers,
                        ...this.defaultHeaders,
                    };
                    return ajaxrx({
                        url: this.API_HOST + url,
                        body: data,
                        method: 'POST',
                        headers: completeHeaders,
                        withCredentials: true
                    });
                },
            );
    }

    static upload(url: string, file: any, data?: {}, headers?: {}): Observable<AjaxResponse> {
        return this.getTokenAsObservable()
            .flatMap(
                (token: string) => {
                    const completeHeaders = {
                        "X-XSRF-TOKEN": token,
                        ...headers,
                        ...this.defaultHeaders,
                    };

                    const fd = new FormData();
                    fd.append("file", file);
                    fd.append("data", JSON.stringify(data));
                    return ajaxrx({
                        url: this.API_HOST + url,
                        body: fd,
                        method: 'POST',
                        headers: completeHeaders,
                        withCredentials: true
                    });
                },
            );
    }

    private static getTokenAsObservable(): any {
        return new Observable((observer) => {
            const token = cookie.load(process.env.REACT_APP_COOKIE_NAME);
            observer.next(token);
            observer.complete();
        });
    }
}

export enum REQUEST {
    PENDING,
    SUCCESS,
    ERROR,
    NONE,
    FORBIDDEN
}


// WEBPACK FOOTER //
// ./src/co/sura/config/ajax-wrapper.ts